import React from 'react';
import AdDisplay from './AdDisplay';

/**
 * Reusable ad slot component
 * @param {Object} props
 * @param {string} props.type - Type of ad: 'sidebar', 'banner', 'in-feed'
 * @param {string} props.position - Position of ad: 'top', 'middle', 'bottom' (optional)
 * @param {string} props.className - Additional CSS classes
 */
const AdSlot = ({ type = 'banner', position = 'top', className = '' }) => {
  return (
    <div className={`ad-slot ad-${type} ad-${position} ${className}`}>
      <AdDisplay type={type} position={position} />
    </div>
  );
};

export default AdSlot;
